import React from 'react';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import './style.css';

const FormSchema = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  email: Yup.string().email('Correo electrónico no es válido').required('Campo requerido'),
  phone: Yup
    .string()
    .max(10, 'El campo debe ser menor a 10 dígitos')
    .required('Campo requerido'),
  message: Yup.string().required('Campo requerido')   ,
});

const ContactForm = () => {

  const onClick = () => { 
    document.querySelector<HTMLFormElement>('#contact-form').submit();
  }

  return (
    <Formik
      initialValues={{ name: '', email: '', phone: '', message: '' }}
      validationSchema={FormSchema}
      onSubmit={(values, { setSubmitting }) => {}}
    >
      {({
        values,
        handleChange,
        handleBlur,
        isSubmitting,
        isValid,
      }) => (
        <form
          autoComplete="off"
          id="contacto"
          method="POST"
          action="https://formspree.io/soporte@fondimex.com"
          className="form-contact relative material-form max-w-xl p-4 md:p-12"
        >
          <h2 className="form-contact__title mb-8 text-gray-700">Contáctanos</h2>
          <div className="form-group">
            <input
              type="text"
              required
              name="name"
              id="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
            />
            <span className="highlight" />
            <span className="bar" />
            <label htmlFor="name">Nombre completo*</label>
            <ErrorMessage name="name" render={msg => <span className="text-xs text-red-200">{msg}</span>} />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="email"
              id="email"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            <span className="highlight"></span>
            <span className="bar"></span>
            <label htmlFor="email">Correo electrónico*</label>
            <ErrorMessage name="email" render={msg => <span className="text-xs text-red-200">{msg}</span>} />
          </div>
          <div className="form-group">
            <input
              type="number"
              name="phone"
              id="phone"
              required
              maxLength={10}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.phone}
            />
            <span className="highlight" />
            <span className="bar" />
            <label htmlFor="name">Teléfono*</label>
            <ErrorMessage name="phone" render={msg => <span className="text-xs text-red-200">{msg}</span>} />
          </div>
          <div className="form-group">
            <textarea
              name="message"
              id="message"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.message}
            />
            <span className="highlight"></span>
            <span className="bar"></span>
            <label htmlFor="message">Tu mensaje*</label>
            <ErrorMessage name="message" render={msg => <span className="text-xs text-red-200">{msg}</span>} />
          </div>
          <div className="form-group">
            <p className="text-gray-700 text-xs">* Campos obligatorios</p>
          </div>
          <div className="text-right">
            <button
              type="submit"
              disabled={isSubmitting || !isValid}
              onClick={() => onClick()}
              className="bg-green-200 text-white px-6 py-3 rounded-lg inline-block px-10"
            >
              Enviar
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ContactForm;
